<skl-dialog-content-ins>
	<skl-dialog-header-ins
		id="document-item-vat-rate-not-available-dialog-header"
		[title]="'scenes.shared.document-item-vat-rate-not-available.dialog.title' | translate"
		(onClose)="onCancel()">
	</skl-dialog-header-ins>

	<ins-content>
        <div 
			id="document-item-vat-rate-not-available-dialog-message">
			{{viewModel.message}}
		</div>
		<ins-checkbox
			class="checkbox-no-padding align--big-top"
			id="document-item-vat-rate-not-available-dialog-do-not-show-again"
			[(ngModel)]="viewModel.doNotShowAgain"
			[label]="'scenes.shared.document-item-vat-rate-not-available.dialog.dont-show-again' | translate">
		</ins-checkbox>
	</ins-content>

	<ins-footer class="dialog__buttons">
		<skl-button
			typeName="accent"
			id="document-item-vat-rate-not-available-dialog-confirm-button"
			(click)="onConfirmAsync()">
			{{'scenes.shared.document-item-vat-rate-not-available.dialog.button.ok' | translate}}
		</skl-button>
	</ins-footer>
</skl-dialog-content-ins>